import {
  AfterContentChecked,
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-infinite-dropdown',
  templateUrl: './infinite-dropdown.component.html',
  styleUrls: ['./infinite-dropdown.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InfiniteDropdownComponent implements OnInit, AfterContentChecked {
  @Output() loadMore = new EventEmitter();
  @Output() onFilter = new EventEmitter();
  @Input() label: string;
  @Input() styleClass;
  @Input() options: any[] = [];
  @Input() placeholder = 'Select';
  @Input() optionLabel = 'label';
  @Input() optionValue = 'value';
  @Input() fControlName: string;
  @Input() defaultLabelValue: string;
  @Input() paginator = null;
  @Input() showSearch = false;
  @Input() enableLoadMore = true;

  selectedOption;
  currentPage = 1;
  showOptionsContainer = false;
  filterForm = this.fb.group({
    search: '',
  });
  subscriptions: Subscription[] = [];

  constructor(
    public controlContainer: ControlContainer,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    const formGroup = this.controlContainer.control as FormGroup;

    this.selectedOption = {
      label: this.defaultLabelValue,
      value: formGroup?.controls[this.fControlName].value,
    };

    this.subscriptions.push(
      formGroup.controls[this.fControlName]?.valueChanges.subscribe((value) => {
        if (!value) {
          this.selectedOption = null;
        }
      })
    );

    this.filterForm
      .get('search')
      .valueChanges.pipe(debounceTime(500)) // Adjust the debounce time as needed (e.g., 300 milliseconds)
      .subscribe((value) => {
        this.onFilterData();
      });
  }

  ngAfterContentChecked(): void {
    const formGroup = this.controlContainer.control as FormGroup;

    this.selectedOption = {
      label: this.defaultLabelValue,
      value: formGroup?.controls[this.fControlName].value,
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  onSelectOption(value) {
    this.selectedOption = value;
    this.defaultLabelValue = value?.label;
    this.showOptionsContainer = false;
    const formGroup = this.controlContainer.control as FormGroup;
    formGroup.controls[this.fControlName]?.setValue(value?.value);
  }

  onReset() {
    this.filterForm.controls['search'].setValue('');
    this.onSelectOption(null);
  }

  onLoadMore() {
    this.currentPage++;
    this.loadMore.emit(this.currentPage);
  }

  onFilterData() {
    this.onFilter.emit(this.filterForm.value.search);
  }
}
